/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateWorkbookTaskItemCommand
 */
export interface CreateWorkbookTaskItemCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateWorkbookTaskItemCommand
     */
    workbookTaskId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateWorkbookTaskItemCommand
     */
    inventoryId: string;
    /**
     * 
     * @type {number}
     * @memberof CreateWorkbookTaskItemCommand
     */
    itemCount?: number;
}

export function CreateWorkbookTaskItemCommandFromJSON(json: any): CreateWorkbookTaskItemCommand {
    return CreateWorkbookTaskItemCommandFromJSONTyped(json, false);
}

export function CreateWorkbookTaskItemCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateWorkbookTaskItemCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workbookTaskId': json['workbookTaskId'],
        'inventoryId': json['inventoryId'],
        'itemCount': !exists(json, 'itemCount') ? undefined : json['itemCount'],
    };
}

export function CreateWorkbookTaskItemCommandToJSON(value?: CreateWorkbookTaskItemCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workbookTaskId': value.workbookTaskId,
        'inventoryId': value.inventoryId,
        'itemCount': value.itemCount,
    };
}


